var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"marquee",style:(_vm.backStyle)},[_c('v-text-marquee',{attrs:{"speed":_vm.speed,"content":_vm.item.text}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }